export default __webpack_public_path__ + "static/media/Citywalks-hover.1ac1b2ad.svg";